export const formatBookingReference = (raw: string) => raw.replaceAll(/[^a-z0-9/]/gi, '').toUpperCase();

export const formatBookingLastName = (raw: string) => formatLastName(raw.replaceAll(/[^\p{L}\s'-]/gu, ''));
